module.exports = __webpack_public_path__ + "static/3805eba7-24c2-41ba-91d2-8fa5db02bc00-995092c837668e827e99edb3e5c80f36.eot";